import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {SharedModule} from "./shared/shared.module";
import {AuthenticationService} from "./services/authentication.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public isIframe = false;

  constructor(private authenticationService: AuthenticationService) {
  }

  async ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
  }
}
